export default function popper(data){
    this.dataAdd("conf/popper",data);
}